import { NavLink } from 'react-router-dom';

import {
  Box,
  Group,
  Menu,
  rem,
  ScrollArea,
  Text,
  ThemeIcon,
} from '@mantine/core';
import { closeModal, openModal } from '@mantine/modals';
import {
  IconChevronRight,
  IconKey,
  IconLogout,
  IconUserCircle,
} from '@tabler/icons-react';

import useAuth from '@hooks/useAuth';
import useUserRoleGuard from '@hooks/useUserRoleGuard';

import EditUserPasswordForm from '@components/EditUserPasswordForm';

import { linksData } from '../../../data/linksData';
import classes from './Sidebar.module.css';
import logo from '@assets/images/logo.png';

export default function Sidebar() {
  const { user, logout } = useAuth();

  const userIsCustomer = useUserRoleGuard('customer');
  const userIsAdmin = useUserRoleGuard('admin');

  const handleEditPasswordClick = () => {
    openModal({
      modalId: 'editUserForm',
      title: 'Modifica password',
      children: (
        <EditUserPasswordForm onSubmit={() => closeModal('editUserForm')} />
      ),
    });
  };

  const links = linksData
    .filter(
      (item) =>
        (item.roles?.includes('customer') && userIsCustomer) ||
        (item.roles?.includes('admin') && userIsAdmin),
    )
    .map((item) => (
      <NavLink key={item.label} to={item.link} className={classes.link}>
        <Group justify="space-between" gap={0}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <ThemeIcon variant="light" size={30}>
              <item.icon style={{ width: rem(18), height: rem(18) }} />
            </ThemeIcon>
            <Box ml="md">{item.label}</Box>
          </Box>
        </Group>
      </NavLink>
    ));

  return (
    <nav className={classes.sidebar}>
      <div className={classes.header}>
        <a href="https://www.prodottigianni.com" target="_blank">
          <img src={logo} alt="Prodotti Gianni" style={{ width: '100%' }} />
        </a>
      </div>

      <ScrollArea className={classes.links}>
        <div className={classes.linksInner}>{links}</div>
      </ScrollArea>

      <div className={classes.footer}>
        <Menu position="right-end" withArrow>
          <Menu.Target>
            <Group wrap="nowrap" className={classes.user}>
              <IconUserCircle size="2rem" />

              <div style={{ flex: 1 }}>
                <Text size="sm" fw={500}>
                  {user?.firstName} {user?.lastName}
                </Text>

                <Text c="dimmed" size="xs">
                  {user?.email}
                </Text>
              </div>

              <IconChevronRight
                style={{ width: rem(14), height: rem(14) }}
                stroke={1.5}
              />
            </Group>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={handleEditPasswordClick}>
              <Group>
                <IconKey size="1.5rem" />
                <Text size="sm">Modifica password</Text>
              </Group>
            </Menu.Item>
            <Menu.Item onClick={logout} c="red">
              <Group>
                <IconLogout size="1.5rem" />
                <Text size="sm">Logout</Text>
              </Group>
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </div>
    </nav>
  );
}
